export class NewMenuAddService {
    constructor($resource, $cookies, ApiService) {
        'ngInject';

        this.$resource = $resource;
        this.apiService = ApiService;

        this.newMenuAddResourceUrl = this.apiService.getResourceUrl('cms/menus');
        this.newMenuAddResource = this.$resource(this.newMenuAddResourceUrl);
    }

    addNewMenu(details) {
        const promise = this.newMenuAddResource.save(this._setNewMenuDetails(details)).$promise;

        return promise
            .then(data => data)
            .catch(err => {
                throw this.apiService.getErrorMessage(err);
            });
    }

    _setNewMenuDetails({ menuId: menu_id, title, overview, description }) {
        return {
            menu_id,
            title,
            overview,
            description
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/common/components/feature-main-page-template/new-menu-add/new-menu-add.service.js